import Vue from 'vue'

var Globals = {
	install: function (Vue, options) {
		var globals = {
	    	getErrorCode : getErrorCode,
	    	getData: getData,
	    	getSection: getSection,
	    	cutSection: cutSection,
	    	loadDataFromServer: loadDataFromServer,
			randomId: randomId

	    };

		Vue.$globals = globals;
		Vue.prototype.$globals = globals;
	}
}

Vue.use(Globals)

function randomId(length) {
   var result           = '';
   var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
   var charactersLength = characters.length;
   for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
   }
   return result;
}


function getData(vue, url, callback) {
	vue.server_status = Vue.$cons.STATUS.LOADING;
	axios
	.get(url)
    .then(response => {
      vue.data = response.data;
	  vue.server_status = Vue.$cons.STATUS.DATA;

      if(callback !== undefined) {
    	  callback();
      }
    })
    .catch(error => {
    	console.log(error)
    	vue.server_status = Vue.$cons.STATUS.ERROR;
    	if(error.response !== undefined) {
    		vue.error_msg = error.response.data;
    	}
    	if(Vue.$cons.ERROR.NOTLOGGEDIN == getErrorCode(error)) {
        	Vue.$auth.logout();
    	}
    });
}

function loadDataFromServer (vue, url, name, callback) {
	vue.server_status = Vue.$cons.STATUS.LOADING;
	axios
	.get(url)
    .then(response => {
      vue[name] = response.data;
	  vue.server_status = Vue.$cons.STATUS.DATA;

      if(callback !== undefined) {
    	  callback();
      }
    })
    .catch(error => {
    	console.log(error)
    	vue.server_status = Vue.$cons.STATUS.ERROR;
    	if(error.response !== undefined) {
    		vue.error_msg = error.response.data;
    	}
    	if(Vue.$cons.ERROR.NOTLOGGEDIN == getErrorCode(error)) {
        	Vue.$auth.logout(true);
    	}
    });
}

function getSection(url, section) {
	var sections = url.split("/");
	if(section in sections) {
		return sections[section];
	} else {
		return "";
	}
}

function cutSection(url, section) {
	var sections = url.split("/");
	var newUrl = "/";
	for (var i = 1; i <= section; i++) {
		newUrl += sections[i] + "/";
	}
	return newUrl;
}

function getErrorCode(e) {
	if (e.response) {
		if(e.response.status === 401) {
			return (Vue.$cons.ERROR.NOTLOGGEDIN);
		}
		return (Vue.$cons.ERROR.INTERNAL);
	}
	return (Vue.$cons.ERROR.NORESPONSE);
}



// WEBPACK FOOTER //
// ./src/javascript/plugins/globals.js